import { Routes, Route, Navigate } from "react-router-dom"
import HomePage from "./pages/HomePage"
import EditorPage from "./pages/EditorPage"

function App() {
  console.log("App rendering")

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/editor" element={<EditorPage />} />
      {/* Fallback route - redirect to home if no match */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
